/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaBenchPlayer = {
    properties: {
        fantaPlayerTeam: {
            type: 'FantaPlayerTeam',
            isRequired: true,
        },
        order: {
            type: 'number',
            isRequired: true,
        },
        points: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
